/* IC IMPROVEMENTS GLOBAL v1.5 — + Calculator SEO content + WebApplication schema */
(function() {
  'use strict';

  var styleEl = document.createElement('style');
  styleEl.id = 'ic-improvements-style';
  styleEl.textContent = '.ic-visually-hidden{position:absolute!important;width:1px!important;height:1px!important;padding:0!important;margin:-1px!important;overflow:hidden!important;clip:rect(0,0,0,0)!important;white-space:nowrap!important;border:0!important;}'+
    '.ic-extra-content{padding:60px 24px;max-width:760px;margin:40px auto;font-family:Lato,system-ui,sans-serif;color:#1A1612;line-height:1.7;background:#F5F0E8;}'+
    '.ic-extra-content h2{font-family:"Lora",Georgia,serif;font-style:italic;font-weight:500;font-size:clamp(26px,4vw,38px);line-height:1.15;margin:36px 0 16px;color:#1A1612;letter-spacing:-0.01em;}'+
    '.ic-extra-content h2:first-child{margin-top:0;}'+
    '.ic-extra-content h3{font-family:Lato,system-ui,sans-serif;font-weight:900;font-size:18px;letter-spacing:0.02em;margin:28px 0 12px;color:#1A1612;}'+
    '.ic-extra-content p{font-size:16px;margin-bottom:16px;color:rgba(26,22,18,0.85);}'+
    '.ic-extra-content strong{color:#1A1612;font-weight:700;}'+
    '.ic-extra-content ul{list-style:none;padding:0;margin:14px 0 22px;}'+
    '.ic-extra-content li{font-size:15px;padding:5px 0;color:rgba(26,22,18,0.85);position:relative;padding-left:18px;}'+
    '.ic-extra-content li::before{content:"·";color:#C9A96E;position:absolute;left:0;font-weight:900;font-size:20px;line-height:1;}'+
    '.ic-extra-content .ic-eyebrow{font-size:11px;font-weight:900;letter-spacing:0.2em;text-transform:uppercase;color:#C9A96E;margin-bottom:14px;}'+
    '.ic-extra-divider{width:60px;height:2px;background:#C9A96E;margin:48px auto;}'+
    '.ic-recipe-row{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin:16px 0 20px;padding:18px 20px;background:rgba(26,22,18,0.05);border-left:3px solid #C9A96E;font-size:13px;}'+
    '.ic-recipe-row .lbl{font-size:10px;font-weight:900;letter-spacing:0.15em;text-transform:uppercase;color:#C9A96E;margin-bottom:4px;}'+
    '.ic-recipe-row .val{font-size:15px;font-weight:700;color:#1A1612;}'+
    '@media(max-width:600px){.ic-recipe-row{grid-template-columns:repeat(2,1fr);}}';
  document.head.appendChild(styleEl);

  function getPageHandle() {
    var path = location.pathname || '';
    var m = path.match(/\/(?:pages|blogs|products|collections)\/([\w-]+)/);
    return m ? m[1] : '';
  }

  function injectJsonLd(id, data) {
    var existing = document.getElementById(id);
    if (existing) existing.remove();
    var script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  }

  function fixH1Spacing() {
    var els = document.querySelectorAll('h1');
    els.forEach(function(el) {
      var raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!raw) return;
      var fixed = raw.replace(/([,.!?;:])([A-Za-zăâîșțĂÂÎȘȚ])/g, '$1 $2');
      fixed = fixed.replace(/([a-zăâîșț])([A-ZĂÂÎȘȚ])/g, '$1 $2');
      if (fixed !== raw) el.setAttribute('aria-label', fixed);
    });
  }

  function findContentContainer() {
    return document.querySelector('main, #MainContent, .main-content, .wrap, .page-container') || document.body;
  }

  function addPillarPageHeadings() {
    var handle = getPageHandle();
    var main = findContentContainer();
    if (!main) return;
    function injectHeadings(target, list) {
      if (target.querySelector('.ic-injected-h2')) return;
      var wrap = document.createElement('div');
      wrap.className = 'ic-injected-h2-wrap';
      list.forEach(function(text) {
        var h2 = document.createElement('h2');
        h2.className = 'ic-injected-h2 ic-visually-hidden';
        h2.textContent = text;
        wrap.appendChild(h2);
      });
      if (target.firstChild) target.insertBefore(wrap, target.firstChild);
      else target.appendChild(wrap);
    }
    if (handle === 'cafenea') injectHeadings(main, ['Despre cafeneaua Incognito', 'Espresso bar & specialty', 'Bucătărie & mâncare', 'Program & rezervări', 'Cum ajungi']);
    else if (handle === 'prajitorie') injectHeadings(main, ['Despre prăjitoria Incognito', 'Origini active acum', 'Cum prăjim — Diedrich IR-12', 'Loturi mici & prospățime', 'Abonament & livrare']);
    else if (handle === 'about') injectHeadings(main, ['Despre Incognito Coffee', 'Cronologie & spațiu', 'Filosofie & valori']);
  }

  function recipeRow(d, w, t, time) {
    return '<div class="ic-recipe-row">' +
      '<div><div class="lbl">Cafea</div><div class="val">' + d + '</div></div>' +
      '<div><div class="lbl">Apă</div><div class="val">' + w + '</div></div>' +
      '<div><div class="lbl">Temperatură</div><div class="val">' + t + '</div></div>' +
      '<div><div class="lbl">Timp</div><div class="val">' + time + '</div></div>' +
    '</div>';
  }

  function injectCalculatorSEOContent() {
    var handle = getPageHandle();
    if (handle !== 'calculator') return;
    if (document.getElementById('ic-calc-seo-block')) return;
    var main = findContentContainer();
    if (!main) return;

    var section = document.createElement('section');
    section.id = 'ic-calc-seo-block';
    section.className = 'ic-extra-content ic-extra-calculator';

    var html = '';

    html += '<div class="ic-eyebrow">Despre calculator</div>';
    html += '<h2>Calculator rații cafea și proporții de preparare</h2>';
    html += '<p>Calculatorul Incognito calculează rația exactă de apă și cafea pentru orice metodă de preparare — V60, AeroPress, Chemex, French Press, Cold Brew, Moka Pot și Espresso. Poți alege originea, numărul de cești, râșnița pe care o folosești acasă și tipul de apă. Calculatorul ajustează automat rețeta — grame, mililitri, temperatură, timp și treaptă de măcinare.</p>';
    html += '<p>Rețetele sunt calibrate pe loturile reale pe care le prăjim. Pleci de la o rețetă verificată, nu de la o medie generică din cărți de specialty.</p>';

    html += '<h2>Cum se folosește acest calculator online de cafea</h2>';
    html += '<p>1. <strong>Alege cafeaua</strong> dintre cele cinci origini active la noi (Brazil, Honduras, Indonesia, Peru, Tanzania) sau dintre originile istorice. 2. <strong>Alege metoda</strong> de preparare. 3. <strong>Spune-ne câte cești</strong> faci — calculatorul scalează cantitățile. 4. (Opțional) Spune-ne <strong>râșnița ta</strong> — calculatorul convertește treapta de măcinare în click-uri specifice modelului tău (Comandante C40, Timemore C2, Kingrinder K6 și altele). 5. Citești rețeta și pornești brew timer-ul pas cu pas.</p>';
    html += '<p>Poți ajusta orice parametru cu butoanele +/−. Calculatorul îți va spune ce gust va avea modificarea: mai dulce, mai acid, mai cu corp, mai amar. Dacă greșești, butonul de reset readuce rețeta la valorile recomandate.</p>';

    html += '<h2>De ce contează proporția de apă și cafea (brew ratio)</h2>';
    html += '<p>Brew ratio — rația cafea : apă — e variabila cea mai importantă în prepararea cafelei. La 1:15, cafeaua e mai concentrată, cu corp mai plin. La 1:17, e mai delicată, cu aciditate mai pronunțată. Specialty coffee modernă lucrează în general între 1:14 și 1:17 pentru metodele filtru. Espresso e mult mai concentrat (1:2). Cold Brew se face concentrat (1:8) și se diluează la servire.</p>';
    html += '<p>Calculatorul nostru pleacă de la rații standardizate per metodă, calibrate cu loturile noastre. Poți varia rația ca să găsești punctul tău dulce — unii preferă cafea mai diluată, alții mai concentrată.</p>';

    html += '<h2>Rețete ghidate pentru cafea proaspăt prăjită</h2>';
    html += '<p>Mai jos, rațiile noastre de start pentru fiecare metodă. Calculatorul ajustează automat în funcție de origine și număr de cești.</p>';

    html += '<h3>Rețetă V60 — pour-over clasic (rație 1:16)</h3>';
    html += recipeRow('15 g', '240 ml', '92 °C', '3:00 min');
    html += '<p>V60 (Hario V60) e cea mai răspândită metodă de pour-over în specialty. Conul cu un unghi de 60 de grade și striațiile spiralate dau o ceașcă cu claritate ridicată, ideală pentru cafele cu profil acid-fructat. <strong>Bloom</strong>: 30g apă (2× cafea) timp de 30 secunde. <strong>Măcinare</strong>: fin-medie (treapta 5/9 generic). <strong>Filtru</strong>: clătit înainte cu apă fierbinte pentru a elimina gustul de hârtie.</p>';

    html += '<h3>Rețetă AeroPress — flexibilitate și metoda invert (rație 1:14)</h3>';
    html += recipeRow('15 g', '210 ml', '88 °C', '2:00 min');
    html += '<p>AeroPress combină imersia cu presiunea ușoară. Metoda invert (cu pistonul în jos, camera sus) îți dă control deplin asupra timpului. Bloom 30g, 30 sec. Măcinare medie-fină. Toarnă restul de apă, amestecă scurt, atașează capacul cu filtru, întoarce pe ceașcă, apasă încet 30 secunde.</p>';

    html += '<h3>Rețetă Chemex — claritate maximă (rație 1:16.5)</h3>';
    html += recipeRow('30 g', '495 ml', '93 °C', '4:30 min');
    html += '<p>Chemex are filtru gros (de 3 ori decât V60) care reține mai multe uleiuri — cafeaua iese cu corp mai ușor, foarte curată. Ideală pentru cafele cu profil floral sau citric. Tipic pentru 2-4 cești.</p>';

    html += '<h3>Rețetă French Press — imersia clasică (rație 1:17)</h3>';
    html += recipeRow('18 g', '300 ml', '95 °C', '4:00 min');
    html += '<p>French Press are reputația de cafea „mâloasă” dacă nu o faci corect. Cheia: <strong>măcinare grosieră</strong> (ca piper măcinat), apa la 95°C, imersie fixă 4 minute, apasă pistonul doar până la baza ferestrei — nu până la fund — ca să lași sedimentul jos.</p>';

    html += '<h3>Rețetă Cold Brew — extracția la rece (rație 1:8 concentrat)</h3>';
    html += recipeRow('80 g', '640 ml', 'temp cameră', '12-18 ore');
    html += '<p>Cold Brew e cafea făcută la rece, prin imersie lungă. Concentrată, se servește diluată 50/50 cu apă sau lapte. Aciditate scăzută, dulceață naturală puternică. Vara, perfectă. Măcinare cea mai grosieră (ca piper grosier).</p>';

    html += '<h3>Rețetă Moka Pot — espresso italian acasă (rație 1:7)</h3>';
    html += recipeRow('15 g', '100 ml', 'foc mediu', '5:00 min');
    html += '<p>Moka Pot (Bialetti) face cafea sub presiune de aproximativ 2 bar — nu e espresso (9 bar), dar e mai concentrat decât filtru. Pune apă caldă (nu rece) în rezervorul de jos, pentru a accelera încălzirea și a evita gustul ars.</p>';

    html += '<h3>Rețetă Espresso de casă (rație 1:2 normale)</h3>';
    html += recipeRow('18 g', '36 g', '93 °C', '25-30 sec');
    html += '<p>Espresso de casă are propriile sale 100 de pagini de învățat. Cele trei variabile principale: dose (cantitatea de cafea în portafiltru), yield (cantitatea care iese în ceașcă) și time (durata extracției). Calculatorul îți dă și variante Ristretto (1:1.5) și Lungo (1:3) dacă vrei alt stil.</p>';

    html += '<h2>Cum influențează gradul de măcinare extracția cafelei</h2>';
    html += '<p><strong>Mai fin = extracție mai puternică, mai lentă.</strong> Apa stă mai mult în contact cu cafeaua, dizolvă mai mult solid și mai multe arome. Risc: amar, prea concentrat.</p>';
    html += '<p><strong>Mai grosier = extracție mai slabă, mai rapidă.</strong> Apa trece prin cafea mai ușor. Risc: acid, fad, gust de cafea apoasă.</p>';
    html += '<p>Calculatorul nostru îți recomandă punctul de start. De acolo, ajustezi treptat: o treaptă mai fină sau mai grosieră la fiecare încercare, până găsești ce-ți place.</p>';

    html += '<h2>Râșnița potrivită pentru fiecare metodă</h2>';
    html += '<p>Selectorul de râșniță din calculator îți convertește treapta abstractă (5/9, 6/9) în click-urile concrete de pe modelul tău. Suportăm:</p>';
    html += '<ul>'+
      '<li><strong>Comandante C40</strong> — referința industriei, manuala</li>'+
      '<li><strong>Timemore C2 / C2 Max</strong> — râșnița accesibilă de calitate</li>'+
      '<li><strong>Timemore Slim Plus</strong></li>'+
      '<li><strong>Timemore Chestnut X</strong></li>'+
      '<li><strong>Kingrinder K6</strong> — alternativă cu raport preț/calitate excelent</li>'+
      '<li><strong>Baratza Encore</strong> — electrică entry-level pentru filtru</li>'+
      '<li><strong>Hario Skerton Pro</strong></li>'+
    '</ul>';

    html += '<h2>Cum depanezi rețeta dacă gustul nu e perfect</h2>';
    html += '<p>Calculatorul include și o secțiune de troubleshooting („Cafeaua a ieșit altfel?”) cu soluții concrete:</p>';
    html += '<ul>'+
      '<li><strong>Cafea acidă, înțepătoare</strong> = sub-extrasă. Soluția: macină mai fin sau crește temperatura cu 2°C.</li>'+
      '<li><strong>Cafea amară, arsă</strong> = peste-extrasă. Soluția: macină mai grosier sau scade temperatura cu 2°C.</li>'+
      '<li><strong>Cafea slabă, apoasă</strong> = diluată. Soluția: mai multă cafea sau o măcinare mai fină.</li>'+
      '<li><strong>Cafea tulbure, grea</strong> = particule fine prin filtru. Soluția: macină mai grosier, clătește filtrul, toarnă mai lent.</li>'+
    '</ul>';
    html += '<p>Cafea proaspăt prăjită + rația corectă + măcinare proaspătă + apă bună. Restul sunt detalii. Folosește calculatorul ca punct de plecare, gustă, ajustează.</p>';

    section.innerHTML = html;
    main.appendChild(section);
  }

  function injectWebAppSchema() {
    var handle = getPageHandle();
    if (handle !== 'calculator') return;
    injectJsonLd('ic-schema-webapp', {
      '@context': 'https://schema.org', '@type': 'WebApplication',
      'name': 'Calculator Cafea Incognito — Rețete V60, AeroPress, Espresso',
      'url': location.origin + '/pages/calculator',
      'applicationCategory': 'LifestyleApplication',
      'operatingSystem': 'Any (web browser)',
      'browserRequirements': 'Requires JavaScript',
      'inLanguage': document.documentElement.lang || 'ro',
      'description': 'Calculator online pentru cafea de specialitate — calculează rația exactă de apă și cafea pentru V60, AeroPress, Chemex, French Press, Cold Brew, Moka Pot, Espresso. Adaptat per origine, râșniță și număr de cești.',
      'offers': { '@type': 'Offer', 'price': '0', 'priceCurrency': 'RON' },
      'creator': { '@type': 'Organization', 'name': 'Incognito Coffee', 'url': location.origin },
      'featureList': [
        'Rețete pentru V60, AeroPress, Chemex, French Press, Cold Brew, Moka Pot, Espresso',
        'Rații calibrate pentru cafelele Incognito',
        'Selector pentru 8 modele de râșnițe (Comandante, Timemore, Kingrinder, Baratza)',
        'Brew timer cu ghid pas cu pas',
        'Predicție gust și recomandări de ajustare',
        'Estimări Extraction Yield (EY) și TDS'
      ]
    });
  }

  function injectExtraContent() {
    var path = location.pathname || '/';
    var main = findContentContainer();
    if (!main || document.getElementById('ic-extra-content-block')) return;

    var content = null;
    if (path === '/' || path === '/en' || path === '/en/') {
      content = {
        id: 'homepage',
        blocks: [
          { eyebrow: 'Cine suntem', h2: 'Cinci ani de prăjitorie singulară', paragraphs: [
            'Incognito a pornit în 2020 ca o prăjitorie mică din Sectorul 1 al Bucureștiului. Fără cafenea, fără terasă, fără mese. Doar Diedrich-ul IR-12 și loturi mici pentru clienții de acasă și primii parteneri B2B. Cinci ani am stat așa — învățând fiecare cafea pe rând, fără să grăbim nimic.',
            'În decembrie 2025 ne-am mutat în casa de beton aparent de pe strada Institutul Medico-Militar 22, proiectată de arhitectul Bogdan Gyemant-Selin. Cafeneaua și bucătăria au deschis pentru prima dată. Prăjitoria a coborât la subsol, dar a rămas centrul a tot ce facem. Cafeaua urcă două etaje până în ceașcă.',
            'Continuăm să ne descriem ca <strong>prăjitorie care servește cafenea</strong> — nu invers. Distincție subtilă, dar definitorie. Diedrich-ul nu e accent. E sursa.'
          ]},
          { eyebrow: 'Procesul', h2: 'Cum lucrăm cu cafeaua', paragraphs: [
            'Prăjim luni, marți și miercuri — zilele când cafeneaua e închisă pentru public. Asta înseamnă că ce găsești în pachet și-n ceașcă a ieșit din Diedrich săptămâna trecută sau acum câteva zile, nu acum o lună.',
            'Loturile sunt mici. Originile vin și pleacă — uneori avem cinci cafele single-origin în stoc, alteori trei. Nu pretindem că avem toate cafelele lumii în orice moment. Spunem exact ce e disponibil acum și de ce.',
            'Pentru fiecare lot publicăm regiunea exactă, varietatea, procesul de prelucrare, altitudinea, notele de degustare. Fără mister, fără jargon care să te impresioneze.'
          ]},
          { eyebrow: 'Vizita', h2: 'Cafenea joi-duminică. Prăjitorie luni-miercuri.', paragraphs: [
            'Joi până duminică, cafeneaua e deschisă pentru public. Espresso, filtru, cocktailuri seara, vin natural. Terasa lucrează din primăvară până-n octombrie. Adresa: Str. Institutul Medico-Militar 22, Sector 1.',
            'Programul de prăjire în zilele închise nu e compromis logistic — e parte din identitate. Cele trei zile fără clienți sunt liniștea de care Diedrich-ul are nevoie ca să iasă constant ce iese.'
          ]}
        ]
      };
    } else if (getPageHandle() === 'prajitorie') {
      content = {
        id: 'prajitorie',
        blocks: [
          
          { eyebrow: 'Transparență', h2: 'Origini documentate până la fermă', paragraphs: ['Pentru fiecare cafea single-origin publicăm:'],
            list: [
              '<strong>Regiunea exactă</strong> de cultivare — nu doar țara, ci provincia / departamentul / muntele',
              '<strong>Numele fermei sau al cooperativei</strong> când e disponibil',
              '<strong>Varietatea botanică</strong> — Catuai, Bourbon, Caturra, Heirloom, Typica',
              '<strong>Procesul de prelucrare</strong> — Washed, Natural, Pulped Natural, Honey, Wet-Hulled',
              '<strong>Altitudinea</strong> — în metri, intervalul real al fermelor de la care vine lotul',
              '<strong>Notele de degustare</strong> — descriptive, nu evaluative'
            ]
          },
          { eyebrow: 'Ritm', h2: 'Loturi mici, prospățime, schimbare des', paragraphs: [
            'Prăjim 30–80 kg pe săptămână, repartizat în loturi de 3–6 kg pe origine. Un lot complet se termină în 4–8 săptămâni de la prăjire — fereastra în care cafeaua își dă tot ce poate.',
            'Originile se schimbă des. Preferăm 3–5 active, prăjite recent, cu povești pe care le cunoaștem.'
          ]},
          { eyebrow: 'Abonament & B2B', h2: 'Cum cumperi de la noi', paragraphs: [
            'Abonament: 250g, 500g sau 1kg lunar, livrate săptămâna prăjirii. Pauză sau anulare oricând.',
            'HoReCa: oferte angro și profile dedicate. Scrie-ne pe <strong>coffee@incognito-coffee.ro</strong>.'
          ]}
        ]
      };
    } else if (path.match(/^\/blogs\/[\w-]+\/?$/) && !path.match(/\/blogs\/[\w-]+\/[\w-]+/)) {
      content = {
        id: 'blog',
        blocks: [
          { eyebrow: 'Despre acest blog', h2: 'Conținut educațional, scris de prăjitori', paragraphs: [
            'Blogul ăsta există pentru că specialty coffee e încă mic în România, iar majoritatea informației disponibile în RO e ori traducere literală din EN, ori marketing pentru un brand anume. Noi încercăm altceva: să scriem ce am învățat în 15 ani în industrie.',
            'Nimic din ce găsești aici nu e sponsorizat. Listele de echipament reflectă ce am folosit personal sau am văzut funcționând bine la clienți.'
          ]},
          { eyebrow: 'Structură', h2: 'Cum e organizat', paragraphs: ['Conținutul e împărțit pe patru axe:'],
            list: [
              '<strong>Origini</strong> (22 țări) — istoric, regiuni, varietăți, procese',
              '<strong>Metode brewing</strong> (8 metode) — V60, Chemex, AeroPress, French Press, Clever, Moka, Cold Brew, Siphon',
              '<strong>Glosar specialty</strong> (30 termeni) — termeni tehnici explicați simplu',
              '<strong>Întrebări frecvente</strong> — răspunsuri scurte'
            ]
          },
          { eyebrow: 'Când ți-e util', h2: 'Cui se adresează', paragraphs: [
            'Pentru oameni care beau deja cafea atentă și vor să înțeleagă mai mult. Nu începători absoluți, nici profesioniști — undeva la mijloc.',
            'Dacă vrei să cumperi cafea, vezi <a href="/pages/prajitorie">prăjitoria</a>. Dacă vrei să vii la noi, vezi <a href="/pages/cafenea">cafeneaua</a>.'
          ]}
        ]
      };
    }

    if (!content) return;

    var section = document.createElement('section');
    section.id = 'ic-extra-content-block';
    section.className = 'ic-extra-content ic-extra-' + content.id;
    var html = '';
    content.blocks.forEach(function(b, idx) {
      if (idx > 0) html += '<div class="ic-extra-divider"></div>';
      if (b.eyebrow) html += '<div class="ic-eyebrow">' + b.eyebrow + '</div>';
      if (b.h2) html += '<h2>' + b.h2 + '</h2>';
      (b.paragraphs || []).forEach(function(p) { html += '<p>' + p + '</p>'; });
      if (b.list && b.list.length) {
        html += '<ul>';
        b.list.forEach(function(li) { html += '<li>' + li + '</li>'; });
        html += '</ul>';
      }
      (b.extraParagraphs || []).forEach(function(p) { html += '<p>' + p + '</p>'; });
    });
    section.innerHTML = html;
    main.appendChild(section);
  }

  function injectBlogSchema() {
    var path = location.pathname || '';
    if (!path.match(/^\/blogs\/[\w-]+\/?$/)) return;
    var schema = {
      '@context': 'https://schema.org', '@type': 'Blog',
      'name': document.title || 'Blog Cafea Specialty — Incognito Coffee',
      'description': 'Conținut educațional despre cafea specialty: origini, metode brewing, glosar, FAQ.',
      'url': location.origin + path,
      'inLanguage': document.documentElement.lang || 'ro',
      'publisher': { '@type': 'Organization', 'name': 'Incognito Coffee', 'url': location.origin }
    };
    var articleLinks = document.querySelectorAll('a[href*="/blogs/"]');
    var posts = []; var seen = {};
    articleLinks.forEach(function(a) {
      var href = a.href;
      if (!href.match(/\/blogs\/[\w-]+\/[\w-]+/)) return;
      if (seen[href]) return;
      seen[href] = 1;
      var title = a.textContent.trim();
      if (title && title.length > 5 && title.length < 200) posts.push({ '@type': 'BlogPosting', 'headline': title, 'url': href });
    });
    if (posts.length > 0) schema.blogPost = posts.slice(0, 20);
    injectJsonLd('ic-schema-blog', schema);
  }

  function injectOriginSchema() {
    var handle = getPageHandle();
    if (!handle.startsWith('origini-') && handle !== 'origini') return;
    if (handle === 'origini') {
      injectJsonLd('ic-schema-collection-origini', {
        '@context': 'https://schema.org', '@type': 'CollectionPage',
        'name': document.title, 'description': 'Toate originile de cafea specialty prăjite la Incognito Coffee.',
        'url': location.href, 'inLanguage': document.documentElement.lang || 'ro',
        'publisher': { '@type': 'Organization', 'name': 'Incognito Coffee', 'url': location.origin }
      });
      return;
    }
    var countrySlug = handle.replace('origini-', '');
    var countryName = countrySlug.split('-').map(function(s) { return s.charAt(0).toUpperCase() + s.slice(1); }).join(' ');
    var metaDesc = document.querySelector('meta[name="description"]');
    injectJsonLd('ic-schema-article-origini', {
      '@context': 'https://schema.org', '@type': 'Article',
      'headline': document.title || ('Origini cafea ' + countryName),
      'description': (metaDesc && metaDesc.content) || ('Cafeaua din ' + countryName + '.'),
      'url': location.href, 'datePublished': '2026-01-01',
      'dateModified': new Date().toISOString().split('T')[0],
      'inLanguage': document.documentElement.lang || 'ro',
      'author': { '@type': 'Organization', 'name': 'Incognito Coffee', 'url': location.origin },
      'publisher': { '@type': 'Organization', 'name': 'Incognito Coffee', 'url': location.origin },
      'about': { '@type': 'Place', 'name': countryName },
      'isPartOf': { '@type': 'WebSite', 'name': 'Incognito Coffee', 'url': location.origin }
    });
  }

  function injectPrajitorieSchema() {
    var handle = getPageHandle();
    if (handle !== 'prajitorie') return;
    var activeOrigins = [
      { url: '/products/brazil-sao-francisco-da-bela-vista', name: 'Brazil Sao Francisco da Bela Vista' },
      { url: '/products/honduras-siguatepe', name: 'Honduras Siguatepe' },
      { url: '/products/indonesia-java', name: 'Indonesia Java' },
      { url: '/products/peru-cajamarca', name: 'Peru Cajamarca' },
      { url: '/products/tanzania-nyasi-furaha', name: 'Tanzania Nyasi Furaha' }
    ];
    var metaDesc = document.querySelector('meta[name="description"]');
    injectJsonLd('ic-schema-prajitorie', {
      '@context': 'https://schema.org', '@type': 'CollectionPage',
      'name': document.title, 'description': (metaDesc && metaDesc.content) || 'Cafea single-origin prăjită local pe Diedrich IR-12.',
      'url': location.href, 'inLanguage': document.documentElement.lang || 'ro',
      'publisher': { '@type': 'Organization', 'name': 'Incognito Coffee', 'url': location.origin },
      'mainEntity': {
        '@type': 'ItemList', 'name': 'Origini active',
        'itemListElement': activeOrigins.map(function(o, i) {
          return { '@type': 'ListItem', 'position': i + 1, 'url': location.origin + o.url, 'name': o.name };
        })
      }
    });
  }

  function init() {
    try { fixH1Spacing(); } catch (e) {}
    try { addPillarPageHeadings(); } catch (e) {}
    try { injectExtraContent(); } catch (e) {}
    try { injectCalculatorSEOContent(); } catch (e) {}
    try { injectWebAppSchema(); } catch (e) {}
    try { injectBlogSchema(); } catch (e) {}
    try { injectOriginSchema(); } catch (e) {}
    try { injectPrajitorieSchema(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
